
import React, { useEffect, useState } from 'react';
import config from '../../config';
import Header from '../Header';
import Footer from '../Footer';
import { useApi } from '../../ApiContext';

const TrackUtil = () => {
  const username = sessionStorage.getItem("username");
  const mrToken = localStorage.getItem("mr_token");
  const { callApi, setIsApiLoading } = useApi();
  const [clients, setClients] = useState([]);
  const [selectedClientIdConfig, setSelectedClientIdConfig] = useState('');
  const [selectedClientIdStage, setSelectedClientIdStage] = useState('');
  const [selectedClientIdDomain, setSelectedClientIdDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [mrNumber, setMrNumber] = useState('');
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState('');

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      await callApi(async () => {
        setIsApiLoading(true);
        try {
          const response = await fetch(`${config.API_BASE_URL}/activeclients`, {
            headers: {
              'Content-Type': 'application/json',
              'X-Username': username,
              'Authorization': `Bearer ${mrToken}`
            }
          });
          if (response.ok) {
            const data = await response.json();
            setClients(Array.isArray(data.data.ACTIVE_CLIENTS) ? data.data.ACTIVE_CLIENTS : []);
          }
        } catch (err) {
          setClients([]);
        } finally {
          setLoading(false);
          setIsApiLoading(false);
        }
      });
    };
    fetchClients();
  }, []);

  const handleClientChangeConfig = (e) => {
    setSelectedClientIdConfig(e.target.value);
  };

  const handleClientChangeStage = (e) => {
    setSelectedClientIdStage(e.target.value);
  };

  const handleClientChangeDomain = async (e) => {
    const clientId = e.target.value;
    setSelectedClientIdDomain(clientId);
    setDomains([]);
    setSelectedDomain('');
    if (!clientId) return;
    try {
      const response = await fetch(`${config.API_BASE_URL}/loadDomainForClient`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Username': username,
          'Authorization': `Bearer ${mrToken}`
        },
        body: JSON.stringify({ clientId })
      });
      if (response.ok) {
        const data = await response.json();
        setDomains(Array.isArray(data.data.DOMAIN_LIST) ? data.data.DOMAIN_LIST : []);
      }
    } catch (err) {
      setDomains([]);
    }
  };

  // Add this handler for domain selection
  const handleDomainChange = (e) => {
    setSelectedDomain(e.target.value);
  };

  const handleServer1 = () => {
    // Implement server 1 logic
  };

  const handleServer2 = () => {
    // Implement server 2 logic
  };

  return (
    <>
      <Header />
      <div className="container-fluid text-secondary">
        <br />
        <br />
        <br />
        <div className="card text-secondary">
          <div className="card-header">Tracking Utilities</div>
          <div className='card-body custom-card-bg'>
            <div className="card">
              <div className="card-body">
                <div className='card'>
                  <div className='card-header'>Reload Client Config</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className="form-group col-md-3">
                        <label htmlFor="client_select_config" className="text-info fw-bold">Select Client</label>
                        <select
                          id="client_select_config"
                          className="form-select"
                          value={selectedClientIdConfig}
                          onChange={handleClientChangeConfig}
                        >
                          <option value="">Select Client</option>
                          {clients.map((client, idx) => (
                            <option key={idx} value={client.clientId || client.id}>
                              {client.clientName || client.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3 d-flex align-items-end">
                        <div className="d-flex gap-2 w-100">
                          <button type="button" className="btn btn-primary" onClick={handleServer1}>
                            <i className='fa fa-inbox text-light'>&nbsp;Server 1</i>
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleServer2}>
                            <i className='fa fa-inbox text-light'>&nbsp;Server 2</i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div className='card'>
                  <div className='card-header'>Reload Stage Alert</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className="form-group col-md-3">
                        <label htmlFor="client_select_stage" className="text-info fw-bold">Select Client</label>
                        <select
                          id="client_select_stage"
                          className="form-select"
                          value={selectedClientIdStage}
                          onChange={handleClientChangeStage}
                        >
                          <option value="">Select Client</option>
                          {clients.map((client, idx) => (
                            <option key={idx} value={client.clientId || client.id}>
                              {client.clientName || client.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div id="mrn" className="form-group col-md-3">
                        <label htmlFor="mr_number" className="text-info fw-bold">Mr Number</label>
                        <input
                          type="text"
                          id="mr_number"
                          className="form-control"
                          value={mrNumber}
                          onChange={e => setMrNumber(e.target.value)}
                          placeholder="Enter Mr Number"
                        />
                      </div>
                      <div className="form-group col-md-3 d-flex align-items-end">
                        <div className="d-flex gap-2 w-100">
                          <button type="button" className="btn btn-primary" onClick={handleServer1}>
                            <i className='fa fa-inbox text-light'>&nbsp;Server 1</i>
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleServer2}>
                            <i className='fa fa-inbox text-light'>&nbsp;Server 2</i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />

				<div className='card'>
				  <div className='card-header'>Reload Domain</div>
				  <div className='card-body'>
				    <div className='row'>
				      <div className="form-group col-md-3">
				        <label htmlFor="client_select_domain" className="text-info fw-bold">Select Client</label>
				        <select
				          id="client_select_domain"
				          className="form-select"
				          value={selectedClientIdDomain}
				          onChange={handleClientChangeDomain}
				        >
				          <option value="">Select Client</option>
				          {clients.map((client, idx) => (
				            <option key={idx} value={client.clientId || client.id}>
				              {client.clientName || client.name}
				            </option>
				          ))}
				        </select>
				      </div>
				      <div className="form-group col-md-3">
				        <label htmlFor="domain_select" className="text-info fw-bold">Select Domain</label>
				        <select
				          id="domain_select"
				          className="form-select"
				          value={selectedDomain}
				          onChange={handleDomainChange}
				          disabled={domains.length === 0}
				        >
				          <option value="">Select Domain</option>
				          {domains.map((domain, idx) => (
				            <option key={idx} value={domain.id || domain.domainId}>
				              {domain.name || domain.domainName}
				            </option>
				          ))}
				        </select>
				      </div>
					  <div className="form-group col-md-3 d-flex align-items-end">
                          <div className="d-flex gap-2 w-100">
                            <button type="button" className="btn btn-primary" onClick={handleServer1}>
                              <i className='fa fa-inbox text-light'>&nbsp;Server 1</i>
                            </button>
                            <button type="button" className="btn btn-secondary" onClick={handleServer2}>
                              <i className='fa fa-inbox text-light'>&nbsp;Server 2</i>
                            </button>
                          </div>
					  </div>	  
				    </div>
				  </div>
				</div>

              </div>
            </div>
          </div>
        </div>
      </div >
      <Footer />
    </>
  );
};

export default TrackUtil;
